import { orderData } from '../../orderData';

const KEY = 'form-data';

const refs = {
  tripFirstGetIn: document.getElementById('firstTrip-get-in'),
  tripFirstGetOut: document.getElementById('firstTrip-get-out'),
  tripFirstDate: document.getElementById('firstTrip-date'),

  returnTripWrapper: document.getElementById('returnTrip-wrapper'),
  returnTripGetIn: document.getElementById('returnTrip-get-in'),
  returnTripGetOut: document.getElementById('returnTrip-get-out'),
  returnTripDate: document.getElementById('returnTrip-date'),
};

const {
  tripFirstGetIn,
  tripFirstGetOut,
  tripFirstDate,
  returnTripWrapper,
  returnTripGetIn,
  returnTripGetOut,
  returnTripDate,
} = refs;

export function renderTripsInfo() {
  const {
    trip: { time, from, to },
  } = orderData;
  if (!from.address || !to.address) {
    return;
  }

  tripFirstGetIn.textContent = from.address;
  tripFirstGetOut.textContent = to.address;
  tripFirstDate.textContent = time;

  // Оновлюємо інформацію про зворотній маршрут, якщо він є
  if (orderData.returnTrip && orderData.returnTripTime) {
    returnTripWrapper.style.display = 'block';
    returnTripGetIn.textContent = to.address;
    returnTripGetOut.textContent = from.address;
    returnTripDate.textContent = orderData.returnTripTime;
  } else {
    // Якщо зворотній маршрут не вибрано, очищуємо відповідні поля
    returnTripWrapper.style.display = 'none';
    returnTripGetIn.textContent = '';
    returnTripGetOut.textContent = '';
    returnTripDate.textContent = '';
  }
}
